<template>
  <!-- 주의 여기에 pos-rel 하지 말것!! 자연스럽게 부모 anchor에 붙도록 하자 -->
  <div class="outer-facade__container">
    <!-- Status Icons -->
    <div id="exp-bar-layer" class="pos-abs w-100 h-100 my-block">
      <exp-bar class="broadcast-box__font pos-abs w-100" ref="expBar" style="bottom: 0px; z-index: 1">
        <template>
          {{ context.virtupetProfile.name }}
        </template>
      </exp-bar>
    </div>
    <div id="virtupet-name-tag" class="pos-abs w-100 h-100 my-block" style="z-index: 1">
      <div class="d-flex justify-center pos-abs w-100" style="top: 40px">
        <TextLabel class="broadcast-box__font">
          <template>
            <span>{{ context.virtupetProfile.name }}</span>
          </template>
        </TextLabel>
      </div>
    </div>
    <div id="streamer-status-text-layer" class="pos-abs w-100 h-100 my-block" style="z-index: 1">
      <div class="pos-abs w-100 h-100" style="background-color: black; opacity: 0.7"></div>
      <div class="pos-abs d-flex justify-center align-center w-100 h-100" style="z-index: 1">
        <span style="color: white; font-size: 48px"></span>
      </div>
    </div>
    <div id="streamer-message" class="pos-abs w-100 h-100 my-block" style="z-index: 1">
      <div class="pos-abs w-100 h-100" style="background-color: black; opacity: 0.9"></div>
      <div class="pos-abs d-flex justify-center align-center w-100 h-100" style="z-index: 1">
        <span style="color: white; font-size: 48px"></span>
      </div>
    </div>
    <div id="sync-status" class="pos-abs w-100 h-100 my-block" style="z-index: 1">
      <div class="pos-abs" style="bottom: 0; right: 0">
        <v-sync-icon v-show="isSync" :size="40"></v-sync-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { DEFAULT_OUTER_FACADE_VISIBILITY } from "@/schema/FullSchema";

export default {
  props: {
    // ContextSchema.js 참조
    context: {
      type: Object,
      default: () => ({
        virtupetProfile: {},
      }),
    },
  },
  data() {
    return {
      visibility: DEFAULT_OUTER_FACADE_VISIBILITY,
      isSync: false,
    };
  },
  mounted() {
    this.initVisibility(DEFAULT_OUTER_FACADE_VISIBILITY);
  },
  methods: {
    // 지능형: 알아서 추출해서 가린다
    initVisibility(inputVisibility) {
      if (!inputVisibility) return console.warn("W_NOT_INIT_VISIBILITY : visibility obj is empty");

      this.visibility = inputVisibility;

      Object.keys(inputVisibility).forEach((key) => {
        this.updateVisibility(`outerFacade#${key}`, this.visibility[key]);
      });
    },
    // 하나만 업데이트 하는 것
    updateVisibility(targetEl = "", isVisible, userInput) {
      const [prefix, id] = targetEl.split("#");

      if (prefix !== "outerFacade") return;

      const $el = this.$el.querySelector(`#${id}`);
      if (!$el) return;

      const display = isVisible ? "block" : "none";
      $el.style.display = display;

      if (userInput) {
        if (userInput.includes("%10%")) {
          userInput = userInput.replace("%10%", "");
          setTimeout(() => {
            $el.style.display = "none";
          }, 1000 * 10);
        }

        $el.querySelector("span").textContent = userInput;
      }
    },
    showSync() {
      this.isSync = true;
      setTimeout(() => (this.isSync = false), 1000);
    },
    displayExp(level, nextExp, percent) {
      this.$refs.expBar.displayExp(level, nextExp, percent);
    },
    setExpColor(color) {
      if (this.$refs.expBar) this.$refs.expBar.setColor(color);
    },
  },
};
</script>

<style scoped>
.my-block {
  display: block;
}

.pos-abs {
  position: absolute;
}

.w-100 {
  width: 100%;
}

.h-100 {
  height: 100%;
}
</style>
